<!--
  工单详情工单日志
-->
<template>
  <div class="my-table">
    <el-table :data="list">
      <el-table-column label="操作类型" prop="operateType" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作人" prop="operateName" show-overflow-tooltip></el-table-column>
      <el-table-column label="执行结果" prop="operateResult" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="flex-col-center">
            <div class="result-icon"></div>
            <div>{{scope.row.operateResult}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" prop="operateTime" show-overflow-tooltip></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {},
  watch: {},
  mounted () {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.order.sheetLogList(this.id).then(({ data }) => {
        if (data.code == 200) {
          this.list = data.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.my-table {
  margin-top: 35px;
  .result-icon {
    width: 8px;
    height: 8px;
    margin-right: 8px;
    background: #19BE6B;
    border-radius: 50%;
  }
}
</style>
